/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { createContext } from 'use-context-selector';
import { node } from 'prop-types';
import useSWR from 'swr';

import { API_USER_CREDIT, API_USER_SOLD } from 'Constants';
import useUser from 'Hooks/useUser';

export const AccountContext = createContext({
  sold: null,
  soldLoading: false,
  credit: null,
  creditLoading: false,
});

const AccountProvider = ({ children }) => {
  const { data: user } = useUser();

  const {
    data: sold,
    isValidating: soldLoading,
  } = useSWR(user?.email && user?.loggedIn ? `${API_USER_SOLD}?uid=${user.email}` : null, {
    revalidateOnMount: true
  });

  const {
    data: credit,
    isValidating: creditLoading,
  } = useSWR(user?.email && user?.loggedIn ? `${API_USER_CREDIT}?uid=${user.email}` : null, {
    revalidateOnMount: true
  });

  const memoizedAccount = useMemo(() => ({
    sold,
    soldLoading,
    credit,
    creditLoading
  }),
  [sold, soldLoading, credit, creditLoading]
  );

  return (
    <AccountContext.Provider value={ memoizedAccount }>
      { children }
    </AccountContext.Provider>
  );
};

AccountProvider.propTypes = {
  children: node
};

AccountProvider.displayName = 'AccountProvider';

export default AccountProvider;
